import * as types from "./mutation-types";

export default {
    updateItemQuantity({ state, commit, dispatch }, payload) {
        axios.put("/api/cart", payload).then(response => {
            commit(types.UPDATE_STATE, response.data);
        });
    },

    removeItem({ commit, dispatch }, item) {
        axios.delete(`/api/cart/${item.id}`).then(response => {
            commit(types.UPDATE_STATE, response.data);
        });
    },

    saveQuotation({ state, getters, commit }, vm) {
        // commit(types.CHANGE_SUBMITTING_FORM_STATUS, true);

        axios
            .post("/api/quotation", getters.formDataQuotationInsert)
            .then(response => {
                swal(
                    "OK",
                    "Obrigado, solicitação de orçamento enviada, retornaremos seu contato em breve!",
                    "success"
                ).then(value => {
                    window.location.reload(false);
                });
            });
    }
};
